import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions';
import { fetchSeasonMaster } from '../../../seasonMaster/seasonMaster.actions';
import { fetchUnitMaster } from '../../../unitMaster/unitMaster.actions';
import { fetchYarnPOProgramDropdown, fetchYarnPOSalesOrderDropdown, fetchYarnPOSupplierDropdown } from '../../YarnPO/yarnPO/yarnPO.actions';
import { fetchCompactingDCDetailsById } from '../compactingDCDetails/compactingDCDetails.actions';
import {
    CREATE_COMPACTING_DC_FAILURE,
    CREATE_COMPACTING_DC_REQUEST,
    CREATE_COMPACTING_DC_SUCCESS,
    CREATE_USER_FORM_COMPACTING_DC,
    DELETE_COMPACTING_DC_FAILURE,
    DELETE_COMPACTING_DC_REQUEST,
    DELETE_COMPACTING_DC_SUCCESS,
    FETCH_SINGLE_COMPACTING_DC_FAILURE,
    FETCH_SINGLE_COMPACTING_DC_REQUEST,
    FETCH_SINGLE_COMPACTING_DC_SUCCESS,
    FETCH_COMPACTING_DC_FAILURE,
    FETCH_COMPACTING_DC_REQUEST,
    FETCH_COMPACTING_DC_SUCCESS,
    COMPACTING_DC_USERFORM_RESET,
    UPDATE_COMPACTING_DC_FAILURE,
    UPDATE_COMPACTING_DC_REQUEST,
    UPDATE_COMPACTING_DC_SUCCESS,
    COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    FETCH_COMPACTING_DC_INVOICE_REQUEST,
    FETCH_COMPACTING_DC_INVOICE_SUCCESS,
    FETCH_COMPACTING_DC_INVOICE_FAILURE,
    FETCH_COMPACTING_DC_STYLE_REQUEST,
    FETCH_COMPACTING_DC_STYLE_SUCCESS,
    FETCH_COMPACTING_DC_STYLE_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE,
    CHECK_ALL_UPDATE_REQUEST_COMPACTING,
    CHECK_ALL_UPDATE_SUCCESS_COMPACTING,
    CHECK_ALL_UPDATE_FALIURE_COMPACTING,
    CLOSE_BTN_POST_REQUEST_COMPACTING,
    CLOSE_BTN_POST_SUCCESS_COMPACTING,
    CLOSE_BTN_POST_FALIURE_COMPACTING,
    COMPACTING_DC_DIA_REQUEST,
    COMPACTING_DC_DIA_SUCCESS,
    COMPACTING_DC_DIA_FALIURE,
    COMPACTING_PROCESS_PROGRAM_REQUEST,
    COMPACTING_PROCESS_PROGRAM_SUCCESS,
    COMPACTING_PROCESS_PROGRAM_FALIURE,
} from './compactingDC.actionsType';

// FETCH PROPERTY MASTER
export let fetchCompactingDC = (startDate, endDate, unitId, status) => {
    let config = {
        method: 'get',
        // url: `${ConstantApi.knittingDCMasterGET}`,
        url: `${ConstantApi.compactingDCMasterGET}?fromDate=${startDate}&toDate=${endDate}&FldFKUnitId=${-1}&FldIsProcessProgram=${status}`,
        responseTypeRequest: FETCH_COMPACTING_DC_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createCompactingDCUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_COMPACTING_DC, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createCompactingDCMaster = (formData, modalClose, startDate, endDate, isDetail, unitId, userform, status) => {

    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldSupplierPANNo: 'static',
        fldSupplierPhoneNo: 'static',
        flDeliveryAtPANNo: 'static',
        fldDeliveryPhoneNo: 'static',
        ...formData,
        fldFKSupplierID: parseInt(userform.fldFKSupplierID),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: 1 || parseInt(formData.fldFKDepartment),
        fldDCNo: 'Auto Generated',
        fldDCDate: today.toISOString(),
        fldDeliveryStartDate: formData.fldDeliveryStartDate ? formData.fldDeliveryStartDate : today.toISOString(),
        fldDeliveryEndDate: formData.fldDeliveryEndDate ? formData.fldDeliveryEndDate : today.toISOString(),
        fldIsInHouseProduction: formData.fldIsInHouseProduction,
        fldIsReprocess: formData.fldIsReprocess,
        fldIsWithCost: formData.fldIsReprocess === false ? true : formData.fldIsWithCost,

        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: userform.fldIsInHouseDelivery ? 0 : parseInt(userform.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(userform.fldFKDeliveryAt),

        // fldNoofBags: formData.fldNoofBags ? Number(formData.fldNoofBags) : 0,
        fldTotalQty: formData.fldTotalQty ? Number(formData.fldTotalQty) : 0,
        fldInwardQty: 0,
        fldCancelQty: 0,
        fldBalanceQty: 0,
        fldPreparedBy: '',
        fldPrepareDate: formData.fldPrepareDate,
        fldVerifyBy: '',
        fldVerifyDate: formData.fldVerifyDate,
        fldAuthorizeBy: '',
        fldAuthorizeDate: formData.fldAuthorizeDate,

        // fldPreparedBy: 'dummy',
        // fldPrepareDate: today.toISOString(),
        // fldVerifyBy: 'dummy',
        // fldVerifyDate: today.toISOString(),
        // fldAuthorizeBy: 'dummy',
        // fldAuthorizeDate: today.toISOString(),

        fldInwardBy: 'dummy',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: 'dummy',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        fldFKPaymentTerms: parseInt(userform.fldFKPaymentTerms)
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.compactingDCMasterPOST}`,
        responseTypeRequest: CREATE_COMPACTING_DC_REQUEST,
        responseTypeSuccess: CREATE_COMPACTING_DC_SUCCESS,
        responseTypeFailure: CREATE_COMPACTING_DC_FAILURE,
        resetFormData: isDetail ? COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB : COMPACTING_DC_USERFORM_RESET,
        modalClose,
        PoDcInwardNo: 'fldPONO',
        PoDcInwardType: 'DC',
        isPopupOpen: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchCompactingDC(startDate, endDate, unitId, status)
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleCompactingDCMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_COMPACTING_DC_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_COMPACTING_DC_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_COMPACTING_DC_FAILURE,
        singlApiArray: [
            // fetchSeasonMaster(),
            // fetchYarnPOSupplierDropdown('TblCompactingDC'),
            // fetchCommonPropertyById(52),
            // fetchCommonPropertyById(46),
            // fetchCommonPropertyById(28),
            // fetchUnitMaster(),
            // fetchYarnPOProgramDropdown('TblCompactingDC'),
            // fetchYarnPOSalesOrderDropdown(),
            // fetchCompactingDCStyle()
        ]
    };
    return axiosCall(config);
};

export let getCompactingDCInvoiceDataV2 = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCInvoiceGET}/${id}`,
        responseTypeRequest: FETCH_COMPACTING_DC_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_INVOICE_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateCompactingDCMaster = (formData, id, startDate, endDate, unitId, userform) => {
    let today = new Date();
    let data = JSON.stringify({
        ...formData,
        fldId: parseInt(id),
        fldFKSupplierID: parseInt(userform.fldFKSupplierID),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: 1 || parseInt(formData.fldFKDepartment),
        fldDCNo: formData?.fldDCNo,
        fldDCDate: formData?.fldDCDate,
        fldDeliveryStartDate: formData.fldDeliveryStartDate,
        fldDeliveryEndDate: formData.fldDeliveryEndDate,
        fldIsInHouseProduction: formData.fldIsInHouseProduction,
        // fldIsReprocess: formData.fldIsReprocess,
        fldIsReprocess: formData.fldIsReprocess,

        fldIsWithCost: formData.fldIsReprocess === false ? true : formData.fldIsWithCost,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: userform.fldIsInHouseDelivery ? 0 : parseInt(userform.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(userform.fldFKDeliveryAt),

        // fldNoofBags: formData.fldNoofBags ? Number(formData.fldNoofBags) : 0,
        fldTotalQty: formData.fldTotalQty ? Number(formData.fldTotalQty) : 0,

        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldPreparedBy: formData.fldPreparedBy,
        fldPrepareDate: formData.fldPrepareDate,
        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate,
        fldAuthorizeBy: formData.fldAuthorizeBy,
        fldAuthorizeDate: formData.fldAuthorizeDate,
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),

        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        fldFKPaymentTerms: parseInt(userform.fldFKPaymentTerms),
        fldIsPrepared: formData.fldIsPrepared,
        fldIsVerified: formData.fldIsVerified,
        fldIsAuthorized: formData.fldIsAuthorized,
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.compactingDCMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_COMPACTING_DC_REQUEST,
        responseTypeSuccess: UPDATE_COMPACTING_DC_SUCCESS,
        responseTypeFailure: UPDATE_COMPACTING_DC_FAILURE,
        resetFormData: COMPACTING_DC_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchCompactingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteCompactingDCMaster = (id, startDate, endDate, unitId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.compactingDCMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_COMPACTING_DC_REQUEST,
        responseTypeSuccess: DELETE_COMPACTING_DC_SUCCESS,
        responseTypeFailure: DELETE_COMPACTING_DC_FAILURE,
        modalClose: true,
        getAllData: fetchCompactingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

export let fetchCompactingDCStyle = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCStyleGET}?ActionCode=COD`,
        responseTypeRequest: FETCH_COMPACTING_DC_STYLE_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_STYLE_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_STYLE_FAILURE
    };
    return axiosCall(config);
};


export let updateCheckAllCompacting = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.updateAllCloseIconCompacting}/?FldFKPoNo=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CHECK_ALL_UPDATE_REQUEST_COMPACTING,
        responseTypeSuccess: CHECK_ALL_UPDATE_SUCCESS_COMPACTING,
        responseTypeFailure: CHECK_ALL_UPDATE_FALIURE_COMPACTING,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};

export let PostCloseIconApiCompacting = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.postCloseIconCOMPA}?FldId=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CLOSE_BTN_POST_REQUEST_COMPACTING,
        responseTypeSuccess: CLOSE_BTN_POST_SUCCESS_COMPACTING,
        responseTypeFailure: CLOSE_BTN_POST_FALIURE_COMPACTING,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};

export let fetchCompactingDCDetailsDiaFrmStyle = (style, fabGrp, yarnCnt, fabric, fldId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.CompactingDCDetailsDiaFrmStyleGET}?FldFKStyle=${style}&FabGrp=${fabGrp}&YarnCnt=${yarnCnt}&Fab=${fabric}&fldId=${fldId}`,
        responseTypeRequest: COMPACTING_DC_DIA_REQUEST,
        responseTypeSuccess: COMPACTING_DC_DIA_SUCCESS,
        responseTypeFailure: COMPACTING_DC_DIA_FALIURE
    };
    return axiosCall(config);
};

export let fetchCompactingDCProcessProgram = (status) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.getProgramProcessCompacting}?FldIsProcessProgram=${status}`,
        responseTypeRequest: COMPACTING_PROCESS_PROGRAM_REQUEST,
        responseTypeSuccess: COMPACTING_PROCESS_PROGRAM_SUCCESS,
        responseTypeFailure: COMPACTING_PROCESS_PROGRAM_FALIURE
    };
    return axiosCall(config);
};





